const openBtnGift = document.querySelector('#openPopupGift');
const closeBtnGift = document.querySelector('#popup-gift #popup-gift-close');
const popupGift = document.querySelector('#popup-gift');
const popupBackgroundGift = document.querySelector('.popup-cart-gift__background');
const formGift = document.querySelector('form.popup-cart-gift');
const formGiftBtn = document.querySelector('form.popup-cart-gift button');

openBtnGift.addEventListener('click', () => {
  popupGift.classList.add('active');
});

closeBtnGift.addEventListener('click', () => {
  popupGift.classList.remove('active');
});
popupBackgroundGift.addEventListener('click', (e) => {
  popupGift.classList.remove('active');
});
//Show input error messages
function showError(input, message) {
  const formControl = input.parentElement;
  formControl.className = 'popup-cart-gift-input error';
}
//show success colour
function showSucces(input) {
  const formControl = input.parentElement;
  formControl.className = 'popup-cart-gift-input success';
}
function checkRequired(inputArr) {
  var required = true;
  inputArr.forEach(function(input){
    if(input.value.trim() === ''){
      required = false;
      showError(input)
    }else {
      showSucces(input);
    }
  }); return required
}
//check email is valid
function checkEmail(input) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(re.test(input.value.trim())) {
    showSucces(input)
  }else {
    showError(input,'Email is not invalid');
  }
}
formGiftBtn.addEventListener('click', (e) => {
  e.preventDefault();
  let formData = {};
  let formInputArr = formGift.querySelectorAll('input')
  formInputArr.forEach(input => {
    formData[input.getAttribute('name')] = input.value;
  });
  if(!checkRequired(formInputArr)) return;
  let formDataString = JSON.stringify(formData).replace(/\\/g, '').replaceAll('"', '').replaceAll('{', '').replaceAll('}', '')
  updateCartNote(formDataString);
});
function updateCartNote(giftForm) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      note: giftForm
    })
  })
  .then(response => {
    if (response.ok) {
      popupGift.classList.remove('active');
    }
  })
  .catch(error => {
    console.error('Error', error);
  });
}
